import axios from "axios";

// Reset chat assistant session
// params: { userId: number }
const post = ({ userId }) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/ai/user_api/v1/reset_chat_assistant_question", {
        user_id: userId,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response?.data ?? error));
  });
};

const resetChatAssistantQuestion = {
  post,
};

export default resetChatAssistantQuestion;
